module.exports = require("babel-core/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel/polyfill.js
 ** module id = 251
 ** module chunks = 0
 **/